import * as Sentry from '@sentry/react';
import { isCancel } from 'axios';

type AiAction = 'fieldDraft' | 'groupDraft' | 'chat' | 'supplierClassification' | 'iroSuggestion' | 'emissionFactorSuggestion';

export type AiActionOutcome = 'done' | 'notFound' | 'refused' | 'failed' | 'aborted';

export function trackAiAction<Result>({
   action,
   run,
   outcomeOf = () => 'done',
}: {
   action: AiAction;
   run: () => Promise<Result>;
   outcomeOf?: (result: Result) => AiActionOutcome;
}) {
   const span = { op: 'ui.ai.action', name: `ai.${action}`, forceTransaction: true, attributes: { 'ai.action': action } };

   return Sentry.startSpan(span, async (activeSpan) => {
      try {
         const result = await run();

         activeSpan.setAttribute('ai.outcome', outcomeOf(result));

         return result;
      } catch (error) {
         activeSpan.setAttribute('ai.outcome', isCancel(error) ? 'aborted' : 'failed');

         throw error;
      }
   });
}
